<div class="flex w-[24rem] flex-col gap-4" *transloco="let t">
  <ISelect
    class="w-full"
    [options]="catalogBrands"
    [selectedValue]="brandSelected()?.value"
    placeholder="{{ t('brand-merge-modal.select_brand') }}"
    (selectedOptionChange)="selectBrand($event)"
    searchable
  />
  <div class="flex justify-end gap-2" *transloco="let t">
    <IButton label="{{ t('common.cancel') }}" color="gray" variant="ghost" (onClick)="close()" />
    <IButton label="{{ t('common.merge') }}" [disabled]="brandSelected === undefined" (onClick)="merge()" />
  </div>
</div>
